import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
import { akEditorDeleteIconColor, akEditorFullPageNarrowBreakout } from '@atlaskit/editor-shared-styles';
import { expValEqualsNoExposure } from '@atlaskit/tmp-editor-statsig/exp-val-equals-no-exposure';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
/*
  Styles in this file are based on
  packages/editor/editor-core/src/plugins/media/styles.ts
*/
export var resizerItemClassName = 'resizer-item';
export var resizerHoverZoneClassName = 'resizer-hover-zone';
export var resizerExtendedZone = 'resizer-is-extended';
export var resizerHandleClassName = 'resizer-handle';
export var resizerHandleTrackClassName = "".concat(resizerHandleClassName, "-track");
export var resizerHandleThumbClassName = "".concat(resizerHandleClassName, "-thumb");
export var resizerDangerClassName = "".concat(resizerHandleClassName, "-danger");

// akEditorSelectedNodeClassName from '@atlaskit/editor-shared-styles';
var akEditorSelectedNodeClassName = 'ak-editor-selected-node';
export var handleWrapperClass = 'resizer-handle-wrapper';
export var resizerHandleThumbWidth = 3;
export var resizerHandleZIndex = 1;

// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766, Seems perfectly safe to autofix, but comments would be lost…
export var resizerStyles = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t.", " {\n\t\twill-change: width;\n\n\t\t&:hover,\n\t\t&.display-handle {\n\t\t\t& > .", " > .", " {\n\t\t\t\tvisibility: visible;\n\t\t\t\topacity: 1;\n\t\t\t}\n\t\t}\n\n\t\t&.is-resizing {\n\t\t\t& .", " {\n\t\t\t\tbackground: ", ";\n\t\t\t}\n\t\t}\n\n\t\t&.", " {\n\t\t\t& .", " {\n\t\t\t\ttransition: none;\n\t\t\t\tbackground: ", ";\n\t\t\t}\n\t\t}\n\t}\n\n\t.", " {\n\t\tdisplay: flex;\n\t\tvisibility: hidden;\n\t\topacity: 0;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\twidth: 7px;\n\t\ttransition:\n\t\t\tvisibility 0.2s,\n\t\t\topacity 0.2s;\n\n\t\t/*\n      NOTE: The below style is targeted at the div element added by the tooltip. We don't have any means of injecting styles\n      into the tooltip\n    */\n\t\t& div[role='presentation'] {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tmargin-top: ", ";\n\t\t\twhite-space: normal;\n\t\t}\n\n\t\t/*\n      Handle Positions\n    */\n\t\t&.left {\n\t\t\talign-items: flex-start;\n\t\t}\n\t\t&.right {\n\t\t\talign-items: flex-end;\n\t\t}\n\n\t\t/*\n      Handle Sizing\n    */\n\t\t&.small {\n\t\t\t& .", " {\n\t\t\t\theight: 43px;\n\t\t\t}\n\t\t}\n\t\t&.medium {\n\t\t\t& .", " {\n\t\t\t\theight: 64px;\n\t\t\t}\n\t\t}\n\t\t&.large {\n\t\t\t& .", " {\n\t\t\t\theight: 96px;\n\t\t\t}\n\t\t}\n\t\t&.clamped {\n\t\t\t& .", " {\n\t\t\t\theight: clamp(43px, calc(100% - 32px), 96px);\n\t\t\t}\n\t\t}\n\n\t\t/*\n      Handle Alignment\n    */\n\t\t&.sticky {\n\t\t\t& .", " {\n\t\t\t\tposition: sticky;\n\t\t\t\ttop: ", ";\n\t\t\t\tbottom: ", ";\n\t\t\t}\n\t\t}\n\n\t\t&:hover {\n\t\t\t& .", " {\n\t\t\t\tbackground: ", ";\n\t\t\t}\n\n\t\t\t& .", " {\n\t\t\t\tvisibility: visible;\n\t\t\t\topacity: 0.5;\n\t\t\t}\n\t\t}\n\t}\n\n\t.", " {\n\t\tcontent: ' ';\n\t\tdisplay: flex;\n\t\twidth: 3px;\n\t\tmargin: 0 ", ";\n\t\theight: 64px;\n\t\ttransition: background-color 0.2s;\n\t\tborder-radius: 6px;\n\t\tborder: 0;\n\t\tpadding: 0;\n\t\tz-index: 2;\n\t\toutline: none;\n\t\tmin-height: 24px;\n\t\tbackground: ", ";\n\n\t\t&:hover {\n\t\t\tcursor: col-resize;\n\t\t}\n\n\t\t&:focus {\n\t\t\tbackground: ", ";\n\n\t\t\t&::after {\n\t\t\t\tcontent: '';\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: ", ";\n\t\t\t\tright: ", ";\n\t\t\t\tbottom: ", ";\n\t\t\t\tleft: ", ";\n\t\t\t\tborder: 2px solid ", ";\n\t\t\t\tborder-radius: inherit;\n\t\t\t\tz-index: -1;\n\t\t\t}\n\t\t}\n\t}\n\n\t.", " {\n\t\tvisibility: hidden;\n\t\tposition: absolute;\n\t\twidth: 7px;\n\t\theight: calc(100% - 40px);\n\t\tborder-radius: 4px;\n\t\topacity: 0;\n\t\ttransition:\n\t\t\tbackground-color 0.2s,\n\t\t\tvisibility 0.2s,\n\t\t\topacity 0.2s;\n\n\t\t&.none {\n\t\t\tbackground: none;\n\t\t}\n\n\t\t&.shadow {\n\t\t\tbackground: ", ";\n\t\t}\n\n\t\t&.full-height {\n\t\t\tbackground: ", ";\n\t\t\theight: 100%;\n\t\t\tmin-height: 36px;\n\t\t}\n\t}\n\n\t.", " {\n\t\t& .", " {\n\t\t\tbackground: ", ";\n\t\t}\n\t}\n\n\t.", " {\n\t\tposition: relative;\n\t\tdisplay: inline-block;\n\t\twidth: 100%;\n\n\t\t&.", " {\n\t\t\tpadding: 0 ", ";\n\t\t\tleft: ", ";\n\t\t}\n\t}\n\n\t/* This below style is here to make sure the image width is correct when nested in a table */\n\ttable .", ", table .", ".", " {\n\t\tpadding: unset;\n\t\tleft: unset;\n\t}\n"])), resizerItemClassName, handleWrapperClass, resizerHandleClassName, resizerHandleThumbClassName, "var(--ds-border-focused, #388BFF)", resizerDangerClassName, resizerHandleThumbClassName, "var(--ds-icon-danger, ".concat(akEditorDeleteIconColor, ")"), resizerHandleClassName, "var(--ds-space-negative-200, -16px)", resizerHandleThumbClassName, resizerHandleThumbClassName, resizerHandleThumbClassName, resizerHandleThumbClassName, resizerHandleThumbClassName, "var(--ds-space-150, 12px)", "var(--ds-space-150, 12px)", resizerHandleThumbClassName, "var(--ds-border-focused, #388BFF)", resizerHandleTrackClassName, resizerHandleThumbClassName, "var(--ds-space-025, 2px)", "var(--ds-border, #091E4224)", "var(--ds-border-selected, #0C66E4)", "var(--ds-space-negative-050, -4px)", "var(--ds-space-negative-050, -4px)", "var(--ds-space-negative-050, -4px)", "var(--ds-space-negative-050, -4px)", "var(--ds-border-focused, #388BFF)", resizerHandleTrackClassName, "var(--ds-background-selected, #E9F2FF)", "var(--ds-background-selected, #E9F2FF)", akEditorSelectedNodeClassName, resizerHandleThumbClassName, "var(--ds-border-focused, #388BFF)", resizerHoverZoneClassName, resizerExtendedZone, "var(--ds-space-150, 12px)", "var(--ds-space-negative-150, -12px)", resizerHoverZoneClassName, resizerHoverZoneClassName, resizerExtendedZone);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var pragmaticResizerStylesForTooltip = function pragmaticResizerStylesForTooltip() {
  if (expValEqualsNoExposure('platform_editor_breakout_resizing', 'isEnabled', true)) {
    return css({
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
      '.pm-breakout-resize-handle-rail-wrapper': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        cursor: 'col-resize',
        borderRadius: "var(--ds-radius-small, 4px)",
        zIndex: 2,
        // Tootip element
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[role="presentation"]': {
          height: '100%',
          width: '100%'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.pm-breakout-resize-handle-rail-inside-tooltip': {
          height: '100%'
        }
      }
    });
  }
};
export var pragmaticStylesLayoutFirstNodeResizeHandleFix = function pragmaticStylesLayoutFirstNodeResizeHandleFix() {
  if (editorExperiment('advanced_layouts', true) && expValEqualsNoExposure('platform_editor_breakout_resizing', 'isEnabled', true)) {
    return css({
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
      '.fabric-editor-breakout-mark': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has([data-prosemirror-node-name="layoutSection"].first-node-in-document)': {
          // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
          '> .pm-breakout-resize-handle-container': {
            height: 'calc(100% - 8px)'
          }
        }
      }
    });
  }
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var pragmaticResizerStyles = function pragmaticResizerStyles() {
  if (!expValEqualsNoExposure('platform_editor_breakout_resizing', 'isEnabled', true)) {
    return;
  }
  return css({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.fabric-editor-breakout-mark': {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
      '&:has([data-prosemirror-node-name="codeBlock"])': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> .pm-breakout-resize-handle-container--left': {
          left: '-5px'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> .pm-breakout-resize-handle-container--right': {
          right: '-5px'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> .pm-breakout-resize-handle-container': {
          height: 'calc(100% - 12px)'
        }
      },
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
      '&:has([data-prosemirror-node-name="expand"]), &:has([data-prosemirror-node-name="layoutSection"])': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> .pm-breakout-resize-handle-container--left': {
          left: '-25px'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> .pm-breakout-resize-handle-container--right': {
          right: '-25px'
        }
      },
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
      '&:has([data-prosemirror-node-name="expand"])': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> .pm-breakout-resize-handle-container': {
          height: 'calc(100% - 4px)'
        }
      },
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
      '&:has([data-prosemirror-node-name="layoutSection"])': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> .pm-breakout-resize-handle-container': {
          height: 'calc(100% - 8px)'
        }
      },
      // the first node in the document always has margin-top = 0
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
      '&:has(.first-node-in-document)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> .pm-breakout-resize-handle-container': {
          height: '100%'
        }
      }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-container': {
      position: 'relative',
      alignSelf: 'end',
      gridRow: 1,
      gridColumn: 1,
      height: '100%',
      width: 7
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-container--left': {
      justifySelf: 'start'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-container--right': {
      justifySelf: 'end'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-rail': {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      cursor: 'col-resize',
      borderRadius: "var(--ds-radius-small, 4px)",
      transition: 'background-color 0.2s, visibility 0.2s, opacity 0.2s',
      zIndex: 2,
      opacity: 0,
      '&:hover': {
        background: "var(--ds-background-selected, #E9F2FF)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.pm-breakout-resize-handle-thumb': {
          background: "var(--ds-border-focused, #388BFF)"
        }
      }
    },
    // same as 'hover' styles above
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-container--active': {
      background: "var(--ds-background-selected, #E9F2FF)",
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
      '.pm-breakout-resize-handle-thumb': {
        background: "var(--ds-border-focused, #388BFF)"
      }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-hit-box': {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: -20,
      right: -20,
      zIndex: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-thumb': {
      minWidth: resizerHandleThumbWidth,
      // copied from resizeStyles.clamped
      height: 'clamp(27px, calc(100% - 32px), 96px)',
      background: "var(--ds-border, #091E4224)",
      borderRadius: "var(--ds-radius-medium, 6px)",
      // sticky styles
      position: 'sticky',
      top: "var(--ds-space-150, 12px)",
      bottom: "var(--ds-space-150, 12px)"
    }
  });
};
export var pragmaticResizerStylesWithReducedEditorGutter = function pragmaticResizerStylesWithReducedEditorGutter() {
  if (editorExperiment('platform_editor_preview_panel_responsiveness', true) && (expValEqualsNoExposure('advanced_layouts', 'isEnabled', true) || expValEqualsNoExposure('platform_editor_breakout_resizing', 'isEnabled', true))) {
    return css(_defineProperty({}, "@container editor-area (max-width: ".concat(akEditorFullPageNarrowBreakout, "px)"), {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
      '.fabric-editor-breakout-mark': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has([data-prosemirror-node-name="expand"]), &:has([data-prosemirror-node-name="layoutSection"])': {
          // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
          '> .pm-breakout-resize-handle-container': {
            opacity: 0,
            visibility: 'hidden'
          }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has([data-prosemirror-node-name="layoutSection"])': _defineProperty({}, ".".concat(resizerItemClassName), {
          willChange: 'width',
          // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
          '&:hover, &.display-handle': _defineProperty({}, "& > .".concat(handleWrapperClass, " > .").concat(resizerHandleClassName), {
            visibility: 'hidden',
            opacity: 0
          })
        })
      }
    }));
  }
};